import _                         from 'underscore';
import React, { FC, useContext } from 'react';
import { useQuery }              from '@apollo/react-hooks';

import { CorvalHireType, CorvalProjectVersionHireType, Uuid } from '@src/types';

import { formatOption, IFormatOptionValue }     from '@src/util';
import { useProjectTermDictionary }             from '@src/hooks';
import { DecisionEngineQueries }                from '@src/queries';
import { queriesHaveData, queriesLoading }      from '@src/store/_apolloUtil';
import { ProjectContext }                       from "@src/views/pages/projects/ProjectIndexPage";
import { ProjectQueries }                       from '@src/queries/ProjectQueries';
import { QueriedSelectFieldProps, SelectField } from '@src/views/components/forms/formik/SelectField';


interface ProjectVersionHireTypeDropdownProps extends QueriedSelectFieldProps {
    projectId?: Uuid,
    projectVersionId?: Uuid,
    loading?: boolean,
    formatOptions?: object,
}

const defaultProps: ProjectVersionHireTypeDropdownProps = {
    loading:       false,
    formatOptions: {}
};

const ProjectVersionHireTypeDropdown: FC<ProjectVersionHireTypeDropdownProps> = ( _props ) => {

    let { projectId: currentProjectId, projectVersionId: currentProjectVersionId, projectBusinessFunctions } = useContext( ProjectContext ),
        { getTerm }                                                                = useProjectTermDictionary(),
        { formatOptions, ...props }                                                = _props;

    const projectId        = props.projectId ?? currentProjectId ?? undefined,
          projectVersionId = props.projectVersionId ?? currentProjectVersionId ?? undefined;

    const allHireTypesQueryFragment            = DecisionEngineQueries.fragments.HIRE_TYPES.QUERY_RETURN( projectId ),
          projectVersionHireTypesQueryFragment = ProjectQueries.fragments.PROJECT_HIRE_TYPES.QUERY_RETURN( projectId, projectVersionId );

    // let getHireTypesReq = useQuery(
    //     DecisionEngineQueries.queries.GET_HIRE_TYPES( allHireTypesQueryFragment ), {
    //         fetchPolicy: 'cache-and-network',
    //         skip:        !projectId,
    //     } );

    // Need to get all project version hire types to know how they are currently configured for business function grouping
    let getProjectVersionHireTypesReq = useQuery(
        ProjectQueries.queries.GET_PROJECT_HIRE_TYPES( projectVersionHireTypesQueryFragment ), {
            fetchPolicy: 'cache-and-network',
            skip:        !projectId || !projectVersionId,
            variables:   {
                id: projectId
            }
        } );

    let isLoading = ( props.loading || queriesLoading( [ getProjectVersionHireTypesReq ] ) );

    let options = [] as IFormatOptionValue[];

    if( queriesHaveData( [ getProjectVersionHireTypesReq ] ) ){

        const { projectVersionHireTypes } = _.first( getProjectVersionHireTypesReq.data.projects );

        // Group by business function, sort by name
        options = _.chain( projectVersionHireTypes )
                   .mapObject( v => ( { ...v, businessFunction: v.businessFunction.name } ) )
                   .sortBy( 'businessFunction' )
                   .groupBy( 'businessFunction' )
                   .values().map( set => _.sortBy( set, 'name' ) )
                   .flatten().map( ( h: CorvalProjectVersionHireType ) => formatOption( h.hireTypeId, h.name, { group: h.businessFunction.name, ...formatOptions } ) )
                   .value();
    }

    return (
        <SelectField
            useGroupNames={ true }
            { ...props }
            search
            loading={ isLoading }
            options={ options }
        />
    );
};

ProjectVersionHireTypeDropdown.defaultProps = defaultProps;

export { ProjectVersionHireTypeDropdown };
